import {Fancybox} from "@fancyapps/ui";

document.addEventListener("DOMContentLoaded", () => {
    new Category()
});
type ProductFilter = Record<string, undefined|Array<string>>
type FacetAnswer = {
    filtered:Number,
    total:Number
}
type RequestParams = Record<string, any>
type ServerResponse = {
    title: string,
    html: string,
    current: number,
    last: number,
    facets: Record<string, FacetAnswer>
}
class Category {
    category: HTMLElement
    products: HTMLElement
    productContainer: HTMLElement
    filter: HTMLElement|null
    btnSubmit: HTMLElement|null
    productFilter: ProductFilter = {}
    currentPage:number
    abortController: undefined|AbortController
    inputs: undefined|NodeListOf<HTMLInputElement>
    texts:undefined|NodeListOf<HTMLInputElement>


    constructor() {
        this.category = document.getElementById("categoryPage") as HTMLElement
        if (!this.category) {
            throw new Error("Не страница категории")
        }
        this.products = this.category.querySelector('.products') as HTMLElement
        if (!this.products) {
            throw new Error("Не найден блок товаров")
        }
        this.productContainer = this.products.querySelector('.products__container') as HTMLElement
        if (!this.productContainer) {
            throw new Error("Не найден контейнер для товаров")
        }
        this.filter = this.category.querySelector('#filter') as HTMLElement
        this.btnSubmit = null
        this.productFilter = {}
        this.currentPage = this.getInitialPage()
        this.addPagination()
        this.addFilter()
    }

    protected addFilter() {
        if (!this.filter) {
            return
        }
        this.btnSubmit = this.filter.querySelector('button[type=submit]') as HTMLElement
        if (this.btnSubmit) {
            this.btnSubmit.addEventListener('click',  () => {
                Fancybox.close();
            })
        }

        this.filter.addEventListener('submit', (e) => {
            e.preventDefault()
        })
        this.filter.addEventListener('reset', async (e) => {
            if (this.productFilter) {

                const checkboxes = this.filter?.querySelectorAll('.checkbox') as  NodeListOf<HTMLElement>
                checkboxes.forEach(function(label: HTMLElement) {
                    label.style.display = '';
                })
                setTimeout(async () => {
                    await this.updateFilter()
                },300)
            }
        })
        this.inputs = this.filter.querySelectorAll('input[type=checkbox]')
        this.inputs.forEach((el) => {
            el.addEventListener('change', async  () => {
                await this.updateFilter()
            })
        })
        this.texts = this.filter.querySelectorAll('input[type=text]')
        this.texts.forEach((el) => {
            if (el.name !=='vendor_query'){
                el.addEventListener('change', async  () => {
                    await this.updateFilter()
                })
            } else {
                el.addEventListener('change',e => {
                    this.vendorFind(el)
                })
                el.addEventListener('input',e => {
                    this.vendorFind(el)
                })
            }
            
        })
    }

    vendorFind(el:HTMLInputElement) {
        const val = el.value.toLowerCase()
        
        const fieldset = el.closest('.filter__fieldset') as HTMLElement
        const checkboxes = fieldset.querySelectorAll('.checkbox') as NodeListOf<HTMLElement>
        checkboxes.forEach(function(label: HTMLElement) {
            if (val) {
                const input = label.querySelector('input')
                const labelTextEl = label.querySelector('span')
                if (!labelTextEl || !input) {
                    return
                }
                if (input.checked) {
                    return
                }
                if (labelTextEl) {
                    const labelText = labelTextEl.textContent?.toLowerCase() as string
                    if (labelText.includes(val)) {
                        label.style.display = '';
                    } else {
                        label.style.display = 'none';
                    }
                }
            } else {
                label.style.display = 'block'
            }

            
        });
    }

    protected async updateFilter() {
        this.productFilter = this.readFilter()
        await this.loadItems(1, true)
    }

    protected readFilter(): ProductFilter {
        const filters: ProductFilter = {}
        this.inputs?.forEach((item) => {
            if (item.checked) {
                const vendorFilter = item.closest('[data-filter]')?.getAttribute('data-filter')?.split(',')
                if (vendorFilter?.[0] === 'vendor' && vendorFilter[2]) {
                    filters.vendor ??= []
                    filters.vendor.push(vendorFilter[2])
                    return
                }

                const property = item.name.match(/^prop_(\d+)_(\d+)$/)
                if (!property) {
                    return
                }

                const key = `filter[${property[1]}]`
                filters[key] ??= []
                filters[key]?.push(property[2])
            }
        })
        this.texts?.forEach((item) => {
            const [_, type , end] = item.name.split('_')
            if (type === 'query') {
                return
            }
            if (type === 'price') {
                if (filters.price) {
                    return
                }
                const range = this.getChangedRange(type)
                if (range) {
                    filters.price = range
                }
            } else {
                const key = `filter[${type}]`
                if (filters[key]) {
                    return
                }
                const range = this.getChangedRange(type)
                if (range) {
                    filters[key] = range
                }
            }
        })
        return filters
    }

    protected getChangedRange(type: string): [string, string]|null {
        const fromInput = this.filter?.querySelector(`[name="f_${type}_from"]`) as HTMLInputElement|null
        const toInput = this.filter?.querySelector(`[name="f_${type}_to"]`) as HTMLInputElement|null
        const slider = fromInput?.closest('.range')?.querySelector('.range__slider') as HTMLElement|null
        if (!fromInput || !toInput || !slider) {
            return null
        }

        const min = parseInt(slider.dataset.min ?? '', 10)
        const max = parseInt(slider.dataset.max ?? '', 10)
        if (!Number.isFinite(min) || !Number.isFinite(max)) {
            return null
        }

        const inputValue = (input: HTMLInputElement, fallback: number): number => {
            const parsed = parseInt(input.value.replace(/[^\d.-]/g, ''), 10)
            return Number.isFinite(parsed) ? parsed : fallback
        }
        const from = Math.min(max, Math.max(min, inputValue(fromInput, min)))
        const to = Math.min(max, Math.max(from, inputValue(toInput, max)))
        return from === min && to === max ? null : [from.toString(), to.toString()]
    }

    protected addPagination () {
        this.category.addEventListener("click", async (event) => {
            if (!(event.target instanceof HTMLElement)) {
                return
            }
            const button = event.target.closest('button.more') as HTMLButtonElement|null
            if (!button) {
                return
            }

            event.preventDefault()
            if (button.disabled) {
                return
            }

            const page = parseInt(button.dataset.page ?? (this.currentPage + 1).toString(), 10)
            if (!page) {
                return
            }

            button.disabled = true
            button.textContent = 'Загрузка...'
            try {
                await this.loadItems(page)
            } catch (e) {
                button.disabled = false
                button.textContent = 'Показать еще'
                throw e
            }
        })
    }

    getData(page:number):RequestParams {
        const qs:RequestParams = {}
        this.productFilter = this.readFilter()

        // Preserve the original search/category query when requesting the next page.
        // Search results keep `q` in the URL, while the AJAX request itself is POST.
        const currentParams = new URLSearchParams(window.location.search)
        currentParams.forEach((value, key) => {
            const isFilterParam = this.filter && (key === 'vendor' || key === 'price' || key.startsWith('filter['))
            if (key === 'page' || isFilterParam) {
                return
            }
            qs[key] = value
        })

        for (const [key, value] of Object.entries(this.productFilter)) {
            qs[key] = [...new Set(value ?? [])].join(',')
        }

        qs.page = page
        return qs
    }
    getUrl(data:RequestParams) {
        const params = new URLSearchParams()
        for (const [key, value] of Object.entries(data)) {
            if ((key === 'page' && value === 1)
                || (key === 's' && value === 'popular')
                || (key === 'd' && data.s === 'popular' && value === 'asc')) {
                continue
            }
            params.set(key, String(value))
        }
        params.sort()
        return window.location.pathname + (params.size ? `?${params}` : '')
    }
    async loadItems(page:number, replace:boolean = false) {
        const  data = this.getData( page)

        if (this.abortController) {
            this.abortController.abort()
            this.abortController = undefined
        }
        this.abortController = new AbortController();

        const response = await fetch(window.location.pathname, {
            method: "POST",
            headers: {
                Accept: "application/json",
                'X-Requested-With': 'XMLHttpRequest'
            },
            body:this.prepareRequest(data),
            signal:  this.abortController.signal, // Связываем с возможностью отмены
        })
        if (!response.ok) {
            const answer = await response.json()
        } else {
            const answer = await response.json() as ServerResponse
            this.currentPage = answer.current
            if (replace) {
                this.products.outerHTML = answer.html
                this.refreshProductElements()
                window.history.replaceState(window.history.state, '', this.getUrl(data))
            } else {
                this.appendProducts(answer.html)
            }
            this.updateFilterAvailability(answer.facets)
        }

    }
    getInitialPage() {
        const more = this.category.querySelector('button.more') as HTMLButtonElement|null
        if (more && more.dataset.page) {
            return Math.max(parseInt(more.dataset.page, 10) - 1, 1)
        }

        const activePage = this.category.querySelector('.catalog-pagination__item._active') as HTMLElement|null
        if (activePage && activePage.textContent) {
            return parseInt(activePage.textContent, 10) || 1
        }

        return 1
    }
    refreshProductElements() {
        this.products = this.category.querySelector('.products') as HTMLElement
        this.productContainer = this.products.querySelector('.products__container') as HTMLElement
    }
    appendProducts(html:string) {
        const products = this.getResponseProducts(html)
        const productContainer = products?.querySelector('.products__container') as HTMLElement|null
        if (!products || !productContainer) {
            this.productContainer.innerHTML += html
            return
        }

        Array.from(productContainer.children).forEach((product) => {
            this.productContainer.appendChild(product)
        })
        this.replaceProductControl('.catalog__button', products)
        this.replaceProductControl('.catalog-pagination', products)
    }
    getResponseProducts(html:string) {
        const wrapper = document.createElement('div')
        wrapper.innerHTML = html
        return wrapper.querySelector('.products') as HTMLElement|null
    }
    replaceProductControl(selector:string, products:HTMLElement) {
        const current = this.products.querySelector(selector) as HTMLElement|null
        const next = products.querySelector(selector) as HTMLElement|null

        if (current && next) {
            current.replaceWith(next)
            return
        }
        if (current && !next) {
            current.remove()
            return
        }
        if (!current && next) {
            this.products.appendChild(next)
        }
    }
    updateFilterAvailability(facets:Record<string, FacetAnswer> = {}) {
        if (!facets) {
            return
        }
        for (const [key, value] of Object.entries(facets)) {
            const name = 'prop_' + key.replace('filter_property_', '')
            if (this.filter) {
                const el = this.filter.querySelector(`input[name="${name}"]`) as HTMLInputElement
                if (el) {
                    el.disabled = value.filtered === 0 && !el.checked;
                }
            }

        }
    }
    prepareRequest(data:RequestParams) {
        const request = new FormData()
        for (const [key, value] of Object.entries(data)) {
            request.append(key, value)
        }
        return request

    }
    /*
    Старый вариант только показывал или скрывал кнопку "Показать еще".
    Сейчас блок кнопки и пагинации заменяется HTML-ом следующей страницы.

    showPagination() {
        const pagination = this.category.querySelector('button.more') as HTMLElement
        if (pagination) {
            pagination.style.display = ''
        }
    }
    removePagination()
    {
        const pagination = this.category.querySelector('button.more') as HTMLElement
        if (pagination) {
            pagination.style.display = 'none'
        }
    }
    */
}

//
// function loadItems(page:number , replace:boolean = false) {
//     var data = getData(true, page, 'query');
//     var url = getUrl(data);
//
//     if (window.catalogXHR !== undefined) {
//         if (window.catalogXHR.data === data && window.catalogXHR.readyState === 1) {
//             return;
//         }
//         window.catalogXHR.abort();
//     }
//
//     var items = $('#categoryItems');
//     items.addClass('loading');
//
//     window.catalogXHR = $.ajax({
//         method: "POST",
//         url: '',
//         dataType: 'json',
//         data: data,
//         success: function (data) {
//             if (page === undefined || replace === true) {
//                 items.empty();
//             } else {
//                 $('#more-products').remove();
//                 $('#pagination').remove();
//                 $('.remove').remove();
//             }
//             items.removeClass('loading');
//             items.append(data.html);
//
//             $.each(data.facets, function (id, count) {
//                 var element = $('#' + id);
//                 element.find('.filtered').html(count.filtered);
//                 if (count.filtered == '0') {
//                     element.find('input').prop('disabled', true);
//                 } else {
//                     element.find('input').prop('disabled', false);
//                 }
//             });
//
//             $('#filterPointer').find('span').html(data.total);
//
//             window.catalogXHR.url = url;
//
//             var disabled = [];
//             $(':input[disabled]', '#productFilter').each(function () {
//                 disabled.push(this.id);
//             });
//             //document.title = data.title;
//             window.history.pushState({
//                 filter: productFilter,
//                 html: items.html(),
//                 title: data.title,
//                 disabled: disabled
//             }, data.title, url);
//         }
//     });
// }



// function getData(ajax, page, mode) {
//     var sortSelector = $('.sort-mode.active');
//
//     if (sortSelector.length) {
//         productFilter['s'] = sortSelector.data('sort');
//         productFilter['d'] = sortSelector.data('direction');
//     } else {
//         delete productFilter['s'];
//         delete productFilter['d'];
//     }
//
//     productFilter['view-mode'] = $('#viewMode').val();
//
//     var qs = {};
//
//     if ($('#product-search').val() !== '' && window.location.pathname === '/s') {
//         qs.q = $('#product-search').val();
//     }
//
//     $.each(productFilter, function (index, value) {
//         if ((parseInt(index, 10) == index) || (index.lastIndexOf('other', 0) === 0) || (index.lastIndexOf('nlist', 0) === 0)) {
//             qs['filter[' + index + ']'] = value;
//         } else {
//             qs[index] = value;
//         }
//     });
//     if (page !== undefined) {
//         qs.page = page;
//     }
//     if ($(window).width() < 768) {
//         per_page = 8;
//     }
//     if (per_page !== undefined) {
//         qs.per_page = per_page;
//     }
//
//     return qs;
// }
